import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { makeStyles } from "@material-ui/core/styles";
import { Search } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { ReclamosExternosItem } from "./ReclamosExternosItem";
import { BuscadorBandejaPorCuitExterno, BuscadorBandejaPorIdReclamoExterno, TraerReclamosExternos, cleanDocumentacionReclamosExterno } from "../../../../../actions/reclamos/reclamosExternosActions";
import { TraerTipoComentarios, desSeleccionarExternos, setEstadoSolicitudesReclamos } from "../../../../../actions/reclamos/reclamosActions";
import { useForm } from "../../../../../hooks/useForm";
import { RECLAMOS_ESTADOS } from "../../../../../utils/constants";

const useStyles = makeStyles({
    root: {
      padding: 10,
      flexGrow: 1,
      marginTop: 10,
      // width: "100%",
    },
    input: {
      // padding: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
  });
  
  const today = new Date();
  const threeMonthsAgo = new Date(today);
  threeMonthsAgo.setMonth(today.getMonth() - 3);
  
  const stateInitial = {
    idProfesional: "",
    fechaInicio: threeMonthsAgo,
    fechaFin: today,
  };
  

export const GestionReclamosExternos = (props) => {
    const classes = useStyles();
    const [formValues, , , setearValor] = useForm(stateInitial);
    const dispatch = useDispatch();
    const { fechaInicio, fechaFin } = formValues;
    const { estadoSolicitudes, itemsEfector } = useSelector(
      (state) => state.reclamos
    );
    const { areasFisicasUsuario } = useSelector((state) => state.auth);
    const [idReclamo, setIdReclamo] = useState(null);
    const [cuit, setCuit] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [dense, setDense] = useState(true);
    const [page, setPage] = useState(0);

    useEffect(() => {
      const fetchData = () => {
          dispatch(TraerReclamosExternos(estadoSolicitudes, areasFisicasUsuario.idArea,  areasFisicasUsuario.idSubArea, fechaInicio, fechaFin));
          dispatch(desSeleccionarExternos());
          dispatch(cleanDocumentacionReclamosExterno());
          
      };
  
      fetchData();
  

      const interval = setInterval(() => {
          fetchData();
      }, 30000);
  

      return () => clearInterval(interval);
  }, [dispatch, estadoSolicitudes, fechaInicio, fechaFin, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea]);


  useEffect(() => {
    dispatch(TraerTipoComentarios());
  }, [])
  

  
  
    const arrayEstadosSolicitudes = Object.entries(RECLAMOS_ESTADOS);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={4}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                fullWidth
                type="number"
                label="Buscar Por CUIT"
                name="cuit"
                value={cuit}
                autoComplete="off"
                onChange={(e) => setCuit(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ marginTop: -25, marginRight: -10 }}
                    >
                      <IconButton
                        aria-label="Buscar"
                        onClick={() => {
                          dispatch(
                            BuscadorBandejaPorCuitExterno(
                              cuit,
                              areasFisicasUsuario.idArea,
                              areasFisicasUsuario.idSubArea,
                              estadoSolicitudes,
                             fechaInicio, 
                             fechaFin
                            )
                          );
                        }}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                fullWidth
                type="number"
                label="Id caso"
                name="idReclamo"
                value={idReclamo}
                autoComplete="off"
                onChange={(e) => setIdReclamo(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ marginTop: -25, marginRight: -10 }}
                    >
                      <IconButton
                        aria-label="Buscar"
                        onClick={() => {
                          dispatch(
                            BuscadorBandejaPorIdReclamoExterno(
                              idReclamo,
                              areasFisicasUsuario.idArea,
                              areasFisicasUsuario.idSubArea,
                              estadoSolicitudes, 
                              fechaInicio, 
                              fechaFin
                            )
                          );
                        }}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Inicio"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fechaInicio).isValid() ? moment(fechaInicio).format() : null
                  }
                  onChange={(date) => {
                    setearValor("fechaInicio", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Fin"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fechaFin).isValid() ? moment(fechaFin).format() : null}
                  onChange={(date) => {
                    setearValor('fechaFin', date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper style={{ padding: "0.25rem", marginTop: -5 }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoSolicitudes}
            onChange={(e) => {
              dispatch(setEstadoSolicitudesReclamos(e.target.value));
            }}
          >
            {arrayEstadosSolicitudes.map((estadoSolicitud, index) => {
              const label =
                estadoSolicitud[0].charAt(0) +
                estadoSolicitud[0].replace("_", " ").toLowerCase().slice(1);
              return (
                <FormControlLabel
                  key={index}
                  style={{ marginLeft: "0.5rem" }}
                  label={label}
                  value={estadoSolicitud[1]?.toString()}
                  control={<Radio />}
                />
              );
            })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="left">Semáforo</TableCell>
                <TableCell align="left">Estado</TableCell>
                {parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.PENDIENTE ? (
                  <TableCell align="left">Fecha Carga</TableCell>
                ) : (
                  <TableCell align="left">Fecha Enviada</TableCell>
                )}
                <TableCell align="left">Id</TableCell>
                <TableCell align="left">CUIL / CUIT</TableCell>
                <TableCell align="left">Nombre</TableCell>
                <TableCell align="left">Tipo</TableCell>
                <TableCell align="left">Origen</TableCell>
                <TableCell align="left">Categoría</TableCell>
                {/* <TableCell align="left">Derivado</TableCell> */}
                {/* <TableCell align="left">Seccional</TableCell> */}
                {/* <TableCell align="left">Tomada</TableCell> */}
                <TableCell align="left">Área derivado</TableCell>
                <TableCell align="left">Subárea derivado</TableCell>
                {parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.FINALIZADA && (
                  <TableCell align="left">Origen del error</TableCell>
                )}
                {(parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.FINALIZADA ||
                  parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.ANULADA) && (
                  <TableCell align="left">Detalle</TableCell>
                )}
               
                {parseInt(estadoSolicitudes) === RECLAMOS_ESTADOS.PENDIENTE && (
                  <TableCell align="left">Datos</TableCell>
                )}
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {itemsEfector.length > 0 ? (
                // items.map((item) => (
                    itemsEfector
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <ReclamosExternosItem
                      item={item}
                      //setRedirect={setRedirect}
                      //permisosUser={permisosUser}
                      key={item.id?.toString()}
                      estadoSolicitudes={estadoSolicitudes}
                      fechaFin={fechaFin}
                      fechaInicio={fechaInicio}
                      areasFisicasUsuario={areasFisicasUsuario}
                      {...props}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {itemsEfector.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={itemsEfector.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {/* {redirect && (
        <Redirect
          to={{
            pathname: '/autorizaciones',
            state: {
              from: '/autorizaciones/gestion'
            },
          }}
        />
      )} */}
    </Grid>
  )
}
